export const SET_IS_MOBILE_STATUS = 'SET_IS_MOBILE_STATUS';
export const SET_ACTIVE_PLAYER_ID = 'SET_ACTIVE_PLAYER_ID';
export const RESTRICT_ACCESS = 'RESTRICT_ACCESS';
